module.exports = __webpack_public_path__ + "static/img/react.68c488c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/react.png
// module id = ErbA
// module chunks = 0